import { Space } from 'antd';
import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { ProgressBar } from 'components/molecules/progress-bar';
import { logger } from 'services';

const SmallWidth = styled.div`
  width: 200px;
`;

const MediumWidth = styled.div`
  width: 350px;
`;

const LargeWidth = styled.div`
  width: 500px;
`;

export const DemoProgressBarPage: FC = () => {
  const [value, setValue] = useState(20);
  const handleOnChange = (_value) => {
    logger.log(_value);
  };

  return (
    <Space direction="vertical">
      <SmallWidth>
        <ProgressBar value={value} size="small" onChange={setValue} />
      </SmallWidth>
      <MediumWidth>
        <ProgressBar size="middle" onChange={handleOnChange} />
      </MediumWidth>
      <LargeWidth>
        <ProgressBar size="large" onChange={handleOnChange} />
      </LargeWidth>
    </Space>
  );
};
